import ThemeToggle from "./ThemeToggle";
import "./ThemeControl.scss";
import FontSizeSelect from "./FontSizeSelect";
import SettingsIcon from "../../Icons/SettingsIcon";
import { useContext, useState } from "react";
import { AppContext } from "../../Context/AppContext";
import CrossIcon from "../../Icons/Cross";
import LayoutDemo from "./LayoutDemo";

function ThemeControl({}) {
	const [open, setOpen] = useState(false);
	const { theme } = useContext(AppContext);
	return (
		<div
			className='theme-control'
			style={{
				fontSize: `${16 / theme.scaleFactor}px`,
			}}
		>
			<SettingsIcon
				width={3}
				height={3}
				func={() => setOpen((prev) => !prev)}
				className={`settings-icon ${open ? "settings-icon-active" : ""}`}
			/>
			{open ? (
				<div className='theme-control-wrapper'>
					<CrossIcon
						width={2}
						height={2}
						className={"theme-control-close"}
						func={() => setOpen(false)}
					/>
					<h2>Настройки</h2>
					<hr style={{ width: "100%", marginBottom: "0.5em" }}></hr>
					<div style={{ marginBottom: "0.5em" }}>Тема:</div>
					<ThemeToggle />
					<hr style={{ width: "100%", marginBottom: "0.5em" }}></hr>
					<div style={{ marginBottom: "0.5em" }}>Размер шрифта:</div>
					<div>
						Заголовок: <FontSizeSelect target={"headerFontMultiplier"} />
					</div>
					<div>
						Левая колонка:
						<FontSizeSelect target={"bodyLeftFontMultiplier"} />
					</div>
					<div>
						Центральная колонка:
						<FontSizeSelect target={"bodyCenterFontMultiplier"} />
					</div>
					<div>
						Правая колонка:
						<FontSizeSelect target={"bodyRightFontMultiplier"} />
					</div>
					<div>
						Подвал:
						<FontSizeSelect target={"footerFontMultiplier"} />
					</div>
					<LayoutDemo />
				</div>
			) : null}
		</div>
	);
}

export default ThemeControl;
